import { RepositoryFactory } from '@main/factories/repository.factory';
import { SalesforceConnectedCallCrmOps } from '@main/sf-crm-ops/salesforce-connected-call-crm-ops';
import { SalesforceRingIncomingCallCrmOps } from '@main/sf-crm-ops/salesforce-ring-incoming-call-crm-ops';

export class CrmOpsFactory {
  private static salesforceRingIncomingCallCrmOps: SalesforceRingIncomingCallCrmOps;
  static buildSalesforceRingIncomingCallCrmOps(): SalesforceRingIncomingCallCrmOps {
    return (
      this.salesforceRingIncomingCallCrmOps ??
      (this.salesforceRingIncomingCallCrmOps =
        new SalesforceRingIncomingCallCrmOps(
          RepositoryFactory.buildMemUserRepository(),
          RepositoryFactory.buildMemIntegrationRepository(),
        ))
    );
  }

  private static salesforceConnectedCallCrmOps: SalesforceConnectedCallCrmOps;
  static buildSalesforceConnectedCallCrmOps(): SalesforceConnectedCallCrmOps {
    return (
      this.salesforceConnectedCallCrmOps ??
      (this.salesforceConnectedCallCrmOps = new SalesforceConnectedCallCrmOps(
        RepositoryFactory.buildMemUserRepository(),
        RepositoryFactory.buildMemIntegrationRepository(),
      ))
    );
  }
}
